import React, { useContext, useEffect, useCallback, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col, Modal, Button } from "react-bootstrap";
import { PaginationComponent } from "../../components";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import PageLayout from "../../layouts/PageLayout";
import { ButtonComponent } from "../../components/elements";
import { toast } from 'react-toastify';
import { listUserTypes, createUserType, updateUserType } from "../../APIs/UserTypeRequests";
import { listRoles } from "../../APIs/RoleRequests";
import UserTypesTableComponent from "../../components/tables/UserTypesTableComponent";
import LabelFieldComponentWithFristEmpty from "../../components/fields/LabelFieldComponentWithFristEmpty";
export default function UserTypesPage() {

    const { t } = useContext(TranslatorContext);
        
    // State management
    const [userTypes, setUserTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [perPage, setPerPage] = useState(10);
    const [searchFilter, setSearchFilter] = useState('');
    const [pagination, setPagination] = useState({
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0
    });
    
    // Search and filters
    const [searchTerm, setSearchTerm] = useState('');
    
    // Modal states
    const [showModal, setShowModal] = useState(false);
    const [editingUserType, setEditingUserType] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);
    
    // Form states
    const [name, setName] = useState('');
    const [selectedRole, setSelectedRole] = useState('');
    const [selectedSuperior, setSelectedSuperior] = useState('');
    
    // Additional data
    const [roles, setRoles] = useState([]);
    const [allUserTypes, setAllUserTypes] = useState([]);
        
    // Fetch roles
    const fetchRoles = () => {
        listRoles(1, 1000).then((response) => {
            setRoles(response.data.data || []);
            setSelectedRole(response.data.data[0]?.id || '');
        }).catch((error) => {
            console.error('Error fetching roles:', error);
        });
    };

    // Fetch all user types for superior dropdown
    const fetchAllUserTypes = () => {
        listUserTypes(1, 1000, '').then((response) => {
            const userTypeOptions = [
                { id: null, name: '' },
                ...response.data.data
                    .filter(userType => !editingUserType || userType.id !== editingUserType.id)
                    .map(userType => ({ id: userType.id, name: userType.name }))
            ]
            console.log(userTypeOptions);
            setAllUserTypes(userTypeOptions);
        }).catch((error) => {
            console.error('Error fetching user types:', error);
        });
    };

    // Fetch user types
    const fetchUserTypes = (page = 1) => {
        setLoading(true);
        listUserTypes(page, perPage, searchFilter).then((response) => {
            setUserTypes(response.data.data);
            setPagination(response.data.pagination || response.data);
        }).catch((error) => {
            console.error('Error fetching user types:', error);
            toast.error(t('error_fetching_data') || 'Error fetching data');
        }).finally(() => {
            setLoading(false);
        });
        
    };
    
    const handlePageClick = (selected) => {
        fetchUserTypes(selected.selected + 1);
    };

    useEffect(() => {
        fetchUserTypes();
        fetchRoles();
        fetchAllUserTypes();
    }, [perPage, searchFilter]);


    const openCreateModal = () => {
        setEditingUserType(null);
        setName('');
        setShowModal(true);
    };

    const openEditModal = (userType) => {
        setEditingUserType(userType);
        setName(userType.name || '');
        setSelectedRole(userType.role_id || '');
        setSelectedSuperior(userType.superior_id || '');
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setEditingUserType(null);
        setName('');
        setSelectedRole('');
        setSelectedSuperior('');
    };

    // Handle form submission
    const handleSubmit = async () => {
        if (!name.trim()) {
            toast.error(t('name_required') || 'Name is required');
            return;
        }

        try {
            setModalLoading(true);
            const formData = new FormData();
            formData.append('name', name.trim());
            
            if (selectedRole) {
                formData.append('role_id', selectedRole);
            }
            
            if (selectedSuperior) {
                formData.append('superior_id', selectedSuperior);
            }

            if (editingUserType) {
                await updateUserType(editingUserType.id, formData);
                toast.success(t('user_type_updated') || 'User type updated successfully');
            } else {
                await createUserType(formData);
                toast.success(t('user_type_created') || 'User type created successfully');
            }

            closeModal();
            fetchUserTypes(pagination.current_page, searchTerm);
            fetchAllUserTypes(); // Refresh the superior list
        } catch (error) {
            console.error('Error saving user type:', error);
            toast.error(t('error_saving_data') || 'Error saving data');
        } finally {
            setModalLoading(false);
        }
    };


    const thead = [t("name"), t("created"), t("action")];

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{t('user_types')}</h3>
                            <ButtonComponent  className="btn btn-primary m-2" onClick={openCreateModal}>{ t('Create New') }</ButtonComponent>
                        </div>
                    </div>
                </Col>
                
                <Col xl={12}>
                    <div className="mc-card">
                        
                        <Row xs={1} sm={2} xl={4}>
                            <Col>
                                <LabelFieldComponent
                                    label={t('show_by')}
                                    option={["10", "20", "50", "100"] }
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange= {(e)=>{
                                        setPerPage(e.target.value);
                                    }}
                                />
                            </Col>
                            
                            
                            <Col>
                                <LabelFieldComponent
                                    type="search"
                                    label={t('search_by')}
                                    placeholder={''}
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange={(e) => {
                                        setSearchFilter(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row>
                        <UserTypesTableComponent
                            thead={ thead }
                            tbody={ userTypes }
                            refreshPage={ fetchUserTypes }
                            openEditModal={ openEditModal }
                        />
                        <PaginationComponent pagination={pagination} handlePageClick={handlePageClick}/>
                    </div>
                </Col>
            </Row>

            {/* Create/Edit Modal */}
            <Modal show={showModal} onHide={closeModal}  >
                <Modal.Header closeButton style={{padding: '10px'}}>
                    <Modal.Title>
                        {editingUserType ? t('edit_user_type') || 'Edit User Type' : t('create_user_type') || 'Create User Type'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{padding: '10px'}}>
                    <Row>
                        <Col md={12}>
                            <LabelFieldComponent 
                                type="text"
                                label={t('name') || 'Name'}
                                placeholder={t('enter_name') || 'Enter name'}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </Col>
                        
                        <Col md={12}>
                            <LabelFieldComponent 
                                label={t('role') || 'Role'}
                                option={roles.map(role => ({ id: role.id, name: role.name }))}
                                value={selectedRole}
                                onChange={(e) => setSelectedRole(e.target.value)}
                                placeholder={t('select_role') || 'Select Role'}
                            />
                        </Col>
                        <Col md={12}>
                            <LabelFieldComponentWithFristEmpty 
                                label={t('superior_user_type') || 'Superior User Type'}
                                option={allUserTypes}
                                value={selectedSuperior}
                                onChange={(e) => setSelectedSuperior(e.target.value)}
                                placeholder={t('select_superior') || 'Select Superior'}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer style={{padding: '10px'}}>
                    <Button variant="secondary" onClick={closeModal}>
                        {t('cancel') || 'Cancel'}
                    </Button>
                    <ButtonComponent
                        className="mc-btn primary"
                        icon={modalLoading ? "hourglass_empty" : "save"}
                        text={modalLoading ? t('loading') || 'Loading...' : (editingUserType ? t('update') || 'Update' : t('create') || 'Create')}
                        onClick={handleSubmit}
                        disabled={modalLoading}
                    />
                </Modal.Footer>
            </Modal>

            
        </PageLayout>
    );
}